import { useMsal } from '@azure/msal-react';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar, Box, Button, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { logout } from '@/store/reducers/authSlice';
import { Notistack } from '../../Notistack';

export const SidebarFooter = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const { userProfile } = useAppSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    const redirectPath = window.location.search;

    sessionStorage.setItem(
      'postLoginRedirect',
      redirectPath
    );
    sessionStorage.removeItem('isUserCreated');
    instance
      .logoutRedirect({
        postLogoutRedirectUri: `${window.location.origin}/login`,
      })
      .catch((error) => {
        console.error('Logout failed:', error);
        Notistack.generalError('Logout failed');
        window.location.href = '/login';
      });
  };

  return (
    <Box sx={{ mt: 'auto', p: 2 }}>
      <Box
        sx={{
          background: '#F3F4F6',
          borderRadius: '10px',
          p: 1.5,
          mb: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
         <Avatar
            sx={{
              width: { xs: 32, sm: 40 },
              height: { xs: 32, sm: 40 },
              bgcolor: '#E6F4F1',
              color: '#00aa8f',
              flexShrink: 0,
            }}
          >
            <PersonIcon fontSize="small" />
          </Avatar>
        <Typography variant="body1">{userProfile?.firstName || ''} {userProfile?.lastName || ''}</Typography>
      </Box>

      <Button
        fullWidth
        variant="contained"
        sx={{
          backgroundColor: '#00aa8f',
          borderRadius: '10px',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: {
            xs: '0.6rem',
            sm: '1.1rem',
          },
        }}
        onClick={handleLogout}
      >
        <LogoutIcon sx={{ color: 'white', marginRight: '0.3125rem'}} />
        LOGOUT
      </Button>
    </Box>
  );
};
